<template>
  <v-card flat outlined class="kpi-card">
    <div class="kpi-card__bar" :style="{ background: accentColor }" />
    <v-card-text class="pa-4">
      <div class="kpi-card__label">{{ label }}</div>
      <div class="kpi-card__value" :style="{ color: accentColor }">{{ value }}</div>
      <div class="kpi-card__sub">{{ sub }}</div>
    </v-card-text>
    <v-icon class="kpi-card__bg-icon" :style="{ color: accentColor }">{{ icon }}</v-icon>
  </v-card>
</template>

<script>
export default {
  name: 'KpiCard',

  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], required: true },
    sub:   { type: String, default: '' },
    icon:  { type: String, default: 'mdi-information-outline' },
    color: { type: String, default: 'primary' }
  },

  computed: {
    accentColor() {
      return this.$vuetify.theme.currentTheme[this.color] || this.color;
    }
  }
};
</script>

<style scoped>
.kpi-card        { position: relative; overflow: hidden; }
.kpi-card__bar   { position: absolute; top: 0; left: 0; right: 0; height: 3px; }
.kpi-card__label { font-size: 11px; font-weight: 700; letter-spacing: .06em;
                   text-transform: uppercase; opacity: .6; margin-bottom: 8px; }
.kpi-card__value { font-size: 30px; font-weight: 800; line-height: 1; margin-bottom: 4px; }
.kpi-card__sub   { font-size: 12px; opacity: .55; }
.kpi-card__bg-icon {
  position: absolute; right: 14px; top: 50%; transform: translateY(-50%);
  font-size: 48px !important; opacity: .2;
}
</style>
